'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (palette) {
    return {
        background: palette.elPrimary,
        boxShadow: '0 6px 10px 0 ' + palette.elShadow + ', 0 4px 10px 0 ' + palette.elShadow,
        borderRadius: '2px',
        zIndex: palette.zOverlay,

        itemFontSize: palette.tsNormal,
        itemLineHeight: 1.5,
        itemFontWeight: palette.twNormal,
        itemColor: palette.tFilled,
        itemBackground: 'transparent',
        itemPaddingTop: palette.gutter + 'px',
        itemPaddingBottom: palette.gutter + 'px',
        itemPaddingRight: palette.gutter * 2 + 'px',
        itemPaddingLeft: palette.gutter * 2 + 'px',

        hoverItemBackground: palette.elLightest,
        hoverItemCursor: 'pointer',
        hoverItemColor: palette.tFilled
    };
};